import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asCourseTabs" }
const _hoisted_2 = {
  key: 0,
  class: "asCourseTabs_update"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, key) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: key,
        class: _normalizeClass(["asCourseTabs_tab", { '-active': tab.name === _ctx.current }]),
        to: _ctx.getLink(tab.name)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(tab.text) + " ", 1),
          false
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "1"))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["class", "to"]))
    }), 128))
  ]))
}